import { Outlet, createFileRoute } from "@tanstack/react-router";
import logo from "@/shared/assets/logo.png";
import { T } from "@/shared/i18n";
import { LanguageMenu } from "@/features/language/components/language-menu";

const TENDER_APP_URL =
  import.meta.env.VITE_MARKETING_URL ?? "https://tender.app";

const ShareLayout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <header className="border-b border-neutral-100 px-6 py-4">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <a href={TENDER_APP_URL} className="flex items-center gap-2">
            <img src={logo} className="h-8" alt="tender.app" />
          </a>
          <nav className="flex items-center gap-6 text-sm text-neutral-600">
            <LanguageMenu />
            <a
              href="https://www.tender.app/tarieven"
              className="hover:text-neutral-900"
            >
              <T id="Pricing" />
            </a>
            <a
              href="https://www.tender.app/contact"
              className="hover:text-neutral-900"
            >
              <T id="Contact" />
            </a>
            <a
              href="https://go.tender.app/"
              className="rounded-md border border-blue-600 bg-white px-4 py-2 text-blue-600 hover:bg-blue-50"
            >
              <T id="Login" />
            </a>
            <a
              href="https://go.tender.app/auth/signup"
              className="rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
            >
              <T id="Sign up" />
            </a>
          </nav>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-neutral-100 px-6 py-4 text-center text-sm text-neutral-400">
        <T id="Powered by" />{" "}
        <a href={TENDER_APP_URL} className="hover:text-neutral-600">
          tender.app
        </a>
      </footer>
    </div>
  );
};

export const Route = createFileRoute("/share")({
  component: ShareLayout,
});
